var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.text)?_c('div',{staticClass:"text-right"},[_c('small',[_vm._v(" "+_vm._s(Math.ceil((_vm.text.length + 21) / 160))+" / "+_vm._s(_vm.textCount)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }